import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import SellYourHome from "../pages/sell-your-home/page";
import HomeValuation from "../pages/home-valuation/page";
import SellerResources from "../pages/seller-resources/page";
import Blog from "../pages/blog/page";
import BlogDetail from "../pages/blog-detail/page";
import Contact from "../pages/contact/page";
import AdminLogin from "../pages/admin/login/page";
import AdminDashboard from "../pages/admin/page";
import PostEditorPage from "../pages/admin/posts/editor/page";
import AuthGuard from "../components/feature/AuthGuard";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/sell-your-home", element: <SellYourHome /> },
  { path: "/home-valuation", element: <HomeValuation /> },
  { path: "/about", element: <About /> },
  { path: "/seller-resources", element: <SellerResources /> },
  { path: "/blog", element: <Blog /> },
  { path: "/blog/:slug", element: <BlogDetail /> },
  { path: "/contact", element: <Contact /> },
  { path: "/admin/login", element: <AdminLogin /> },
  {
    path: "/admin",
    element: (
      <AuthGuard>
        <AdminDashboard />
      </AuthGuard>
    ),
  },
  {
    path: "/admin/posts/new",
    element: (
      <AuthGuard>
        <PostEditorPage />
      </AuthGuard>
    ),
  },
  {
    path: "/admin/posts/:id/edit",
    element: (
      <AuthGuard>
        <PostEditorPage />
      </AuthGuard>
    ),
  },
  { path: "*", element: <NotFound /> },
];

export default routes;